import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=156658a8&scoped=true"
import script from "./BasicLayout.vue?vue&type=script&lang=js"
export * from "./BasicLayout.vue?vue&type=script&lang=js"
import style0 from "./BasicLayout.vue?vue&type=style&index=0&id=156658a8&prod&scoped=true&lang=css"
import style1 from "./BasicLayout.vue?vue&type=style&index=1&id=156658a8&prod&lang=scss&scoped=true"
import style2 from "./BasicLayout.vue?vue&type=style&index=2&id=156658a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156658a8",
  null
  
)

export default component.exports